import React, { useState } from "react"
import Icon from "../../common/icon/icon.component"
import { FormattedMessage } from "react-intl"
import { ProposalPreviewModalWrapper } from "../modals"
import { ProposalPreviewButtonProps } from "../../common/types/proposal"
import { Button } from "react-bootstrap"

export const ProposalPreviewButton = (props: ProposalPreviewButtonProps) => {
    const [modal, setModal] = useState<React.ReactNode>(null)

    const onModalOpen = () => {
        setModal(
            <ProposalPreviewModalWrapper
                proposalType={props.proposalType}
                proposalHash={props.proposalHash}
                onCloseCallback={() => setModal(null)}
            />
        )
    }

    return (
        <>
            {modal}
            <Button
                variant={"outline-primary btn-sm mr-2"}
                onClick={onModalOpen}
            >
                <Icon value={"eye"} className={"mr-1"}/>
                <FormattedMessage
                    id="common.button.preview.btn"
                    defaultMessage="Preview"
                />
            </Button>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/proposal/components/ProposalPreviewButton.tsx